import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // 每次跳转新页面回到顶部，浏览器前进/后退时恢复原位置
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login/Login.vue'),
      meta: { title: '登录', noAuth: true }
    },
    {
      path: '/',
      name: 'HomePage',
      component: () => import('@/views/HomePage/HomePage.vue')
    },
    {
      path: '/media',
      name: 'MediaPage',
      component: () => import('@/views/MediaPage/MediaPage.vue')
    },
    {
      path: '/media-write',
      name: 'MediaWrite',
      component: () => import('@/views/MediaWrite/MediaWrite.vue')
    },
    {
      path: '/media-pay',
      name: 'MediaPay',
      component: () => import('@/views/MediaPay/MediaPay.vue')
    },
    {
      path: '/media-complete',
      name: 'MediaComplete',
      component: () => import('@/views/MediaComplete/MediaComplete.vue')
    },
    {
      path: '/social/:type',
      name: 'SocialMedia',
      component: () => import('@/views/SocialMedia/SocialMedia.vue')
    },
    {
      path: '/brand/:type',
      name: 'BrandMarketing',
      component: () => import('@/views/BrandMarketing/BrandMarketing.vue')
    },
    {
      path: '/articlewrite',
      name: 'ArticleWrite',
      component: () => import('@/views/ArticleWrite/ArticleWrite.vue')
    },
    {
      path: '/media-entry',
      name: 'MediaEntry',
      component: () => import('@/views/MediaEntry/MediaEntry.vue')
    },
    {
      path: '/wemedia',
      name: 'WeMedia',
      component: () => import('@/views/WeMedia/WeMedia.vue')
    },
    {
      path: '/video-media',
      name: 'VideoMedia',
      component: () => import('@/views/VideoMedia/VideoMedia.vue')
    },
    {
      path: '/user-center',
      name: 'UserCenter',
      component: () => import('@/views/UserCenter/UserCenter.vue'),
      meta: { requireAuth: true }
    },
    {
      path: '/order-preview',
      name: 'OrderPreview',
      component: () => import('@/views/UserCenter/OrderPreview.vue'),
      meta: { requireAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth && !store.state.token) {
    store.commit('SET_LOGIN_DIALOG', { visible: true, message: '请先登录' })
    return next('/media')
  }
  next()
})

export default router
